export default [
  {
    name: 'firstName',
    label: {
      cs: 'Jméno',
      en: 'First name',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'lastName',
    label: {
      cs: 'Příjmení',
      en: 'Last name',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'position',
    label: {
      cs: 'Pozice',
      en: 'Position',
    },
    input: 'select-menu',
    elements: [
      { value: 'commissioner', label: 'Commissioner' },
      { value: 'delegate', label: 'Delegate' },
      { value: 'scorer', label: 'Scorer' },
      { value: 'scorer-supervisor', label: 'Scorer supervisor' },
      { value: 'umpire', label: 'Umpire' },
      { value: 'umpire-supervisor', label: 'Umpire supervisor' },
    ],
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'nationality',
    label: {
      cs: 'Národnost',
      en: 'Nationality',
    },
    input: 'select-menu',
    elements: [
      { value: 'aut', label: 'Austria' },
      { value: 'bel', label: 'Belgium' },
      { value: 'cro', label: 'Croatia' },
      { value: 'cze', label: 'Czechia' },
      { value: 'fin', label: 'Finland' },
      { value: 'fra', label: 'France' },
      { value: 'ger', label: 'Germany' },
      { value: 'gbr', label: 'Great Britain' },
      { value: 'gre', label: 'Greece' },
      { value: 'hun', label: 'Hungary' },
      { value: 'isr', label: 'Israel' },
      { value: 'ita', label: 'Italy' },
      { value: 'ned', label: 'Netherlands' },
      { value: 'svk', label: 'Slovakia' },
      { value: 'esp', label: 'Spain' },
      { value: 'swe', label: 'Sweden' },
      { value: 'sui', label: 'Switzerland' },
      { value: 'ukr', label: 'Ukraine' },
    ],
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
];
